export default __webpack_public_path__ + "static/media/bg-showcase-3.b8a910e6.jpg";